import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { Rock } from '../../types';

interface TriageModalProps {
  isOpen: boolean;
  onClose: () => void;
  rock: Rock;
  onTriage: () => void;
}

/**
 * Triage Modal Component
 * Allows review of dropped rocks for potential reactivation
 */
export function TriageModal({ isOpen, onClose, rock, onTriage }: TriageModalProps) {
  const textColor = useColorModeValue('gray.700', 'gray.300');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Review Dropped Rock for Reactivation</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <Text color={textColor} fontWeight="medium">
              Rock: {rock.rock}
            </Text>
            <Text color={textColor}>
              Measurable: {rock.measurable}
            </Text>
            {rock.notes && (
              <Box>
                <Text color={textColor} fontWeight="medium" mb={2}>
                  Notes:
                </Text>
                <Text color={textColor}>{rock.notes}</Text>
              </Box>
            )}
            <Text color={textColor} fontSize="sm" fontStyle="italic">
              Review this dropped rock to determine if it should be reactivated for the current quarter.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={onTriage}>
            Reactivate Rock
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

